import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ListViewModule } from '@y42/core/list-view';
import { DataTestColumnsCellRendererModule } from '../cell-renderers/data-test-columns-cell-renderer/data-test-columns-cell-renderer.module';
import { DataTestConditionCellRendererModule } from '../cell-renderers/data-test-condition-cell-renderer/data-test-condition-cell-renderer.module';
import { DataTestLatestJobStatusCellRendererModule } from '../cell-renderers/data-test-latest-job-status-cell-renderer/data-test-latest-job-status-cell-renderer.module';
import { DataTestResultCellRendererModule } from '../cell-renderers/data-test-result-cell-renderer/data-test-result-cell-renderer.module';
import { DataTestStatusCellRendererModule } from '../cell-renderers/data-test-status-cell-renderer/data-test-status-cell-renderer.module';
import { DataTestTypeCellRendererModule } from '../cell-renderers/data-test-type-cell-renderer/data-test-type-cell-renderer.module';
import { DataTestCommitButtonModule } from '../data-test-commit-button/data-test-commit-button.module';
import { DataTestSetupListComponent } from './data-test-setup-list.component';

@NgModule({
  declarations: [DataTestSetupListComponent],
  imports: [
    CommonModule,
    ListViewModule,
    DataTestTypeCellRendererModule,
    DataTestConditionCellRendererModule,
    DataTestColumnsCellRendererModule,
    DataTestResultCellRendererModule,
    DataTestStatusCellRendererModule,
    DataTestCommitButtonModule,
    DataTestLatestJobStatusCellRendererModule,
  ],
  exports: [DataTestSetupListComponent],
})
export class DataTestSetupListModule {}
